'use client';

import { ComponentProps, ReactElement } from 'react';

import { Dropdown } from '@flipster/react/design-system/dropdown';
import { useDropdown } from '@flipster/react/design-system/dropdown/dropdown';
import { Modal } from '@flipster/react/design-system/modal';
import { useBreakpoint } from '@flipster/react/misc/responsive';

export const useResponsiveOverlay = () => {
  return useDropdown();
};

interface RootProps extends ComponentProps<typeof Dropdown.Root> {
  inheritWidth?: boolean;
}

const Root = ({ inheritWidth = false, ...props }: RootProps) => {
  const { isMobile } = useBreakpoint();
  return <Dropdown.Root {...props} inheritWidth={inheritWidth} disableDismiss={isMobile} />;
};

const Trigger = Dropdown.Trigger;

interface ContentProps {
  dropdown: ReactElement<ComponentProps<typeof Dropdown.Content>>;
  modal: ReactElement;
  modalSize?: 'small' | 'large';
}

const Content = ({ dropdown, modal, modalSize }: ContentProps) => {
  const { open, setOpen } = useDropdown();
  const { breakpoint, isMobile } = useBreakpoint();

  const handleClose = () => setOpen(false);

  if (!breakpoint) return null;

  if (isMobile) {
    return (
      <Modal.Root isOpen={open} mode='bottomSheet' size={modalSize} onClose={handleClose}>
        {modal}
      </Modal.Root>
    );
  }

  return dropdown;
};

Root.displayName = 'ResponsiveOverlay.Root';
export const ResponsiveOverlay = { Root, Trigger, Content };
